<template>
  <div
    class="postcards-template-settings__wrapper"
    :class="{ [extraClass]: !!extraClass }"
  >
    <div class="postcards-template-settings__header">Settings</div>

    <div class="container top">
      <div class="options pages">
        <span class="header">Size</span>
        <VForm
          :name="name"
          :fields="formData.fieldsSize"
          :initialValues="initialValues"
          @change="val => getTypeValuee(val)"
        ></VForm>
      </div>
      <div
        class="options"
        :class="{ ['usps-standard-disable']: isUspsStandardDisable }"
      >
        <span class="header">Postage Options</span>
        <VForm
          :name="name"
          :fields="formData.fieldsMailType"
          :initialValues="initialValues"
          @change="val => $emit('change', val)"
        ></VForm>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import VueTypes from "vue-types";
import { mapActions, mapGetters } from "vuex";
import cloneDeep from "lodash/cloneDeep";
// components
import VForm from "@/components/VForm";
import VButton from "@/components/VButton";
import VRangeIntInput from "@/components/VRangeIntInput";
import withFormUtils from "@/mixins/withForm";
import letterPreview from "@/assets/images/letter-preview.svg";
import { POSTAGE_OPTIONS, POSTCARDS_SIZES_OPTIONS } from "@/constants/forms";

export default Vue.component("PostcardsTemplateSettingsForm", {
  props: {
    initialValues: VueTypes.object,
    extraClass: VueTypes.string.def("")
  },

  components: { VForm, VButton, VRangeIntInput },

  mixins: [withFormUtils],

  data() {
    return {
      isUspsStandardDisable: false,
      name: "postcardTemplateSettings"
    };
  },

  methods: {
    async getTypeValuee(val) {
      await this.shouldUspsStandardDisable();
      this.$emit("change", val);
    },

    shouldUspsStandardDisable() {
      if (this.getTypeValue === "postcard-4x6") {
        this.isUspsStandardDisable = true;
        this.updateValue({
          formName: this.name,
          fieldName: "mail_type",
          value: "usps_first_class"
        });
      } else {
        this.isUspsStandardDisable = false;
      }
    },

    ...mapActions("lettersTemplates", ["updateLettersTemplate"])
  },

  computed: {
    formData() {
      return {
        fieldsSize: [
          {
            name: "type",
            selectItems: POSTCARDS_SIZES_OPTIONS,
            elementType: "radioGroup"
          }
        ],
        fieldsMailType: [
          {
            name: "mail_type",
            selectItems: POSTAGE_OPTIONS,
            elementType: "radioGroup"
          }
        ]
      };
    },

    _isFormsTouched() {
      return (
        this.isFormTouched("postcardTemplateSettings")
      );
    },

    getTypeValue() {
      return this.getValue("type");
    },

    ...mapGetters("templates", ["isLoading"])
  },

  mounted() {
    this.shouldUspsStandardDisable();
  }

});
</script>

<style lang="scss" scoped>
$ns: "postcards-template-settings";
.#{$ns}__header {
  font-family: Lato-Regular, Arial, sans-serif;
  font-size: 22px;
  line-height: 1.2;
  margin-bottom: 30px;
}
.container {
  display: flex;
}
.header {
  display: inline-block;
  font-family: Lato-Bold, Arial, sans-serif;
  font-size: 16px;
  color: $title-text-color;
  margin-bottom: 30px;
}
.options {
  width: 195px;
  &.pages,
  &.additional {
    margin-right: 18px;
    width: 180px;
  }
  &.postage {
    z-index: 0;
  }
  &.additional {
    position: relative;
  }
  &.extra-postage {
    margin-left: 195px;
    .header {
      cursor: pointer;
      span {
        display: inline-block;
        margin-right: 20px;
      }
    }
  }

  &.usps-standard-disable /deep/ .v-radio-input-group__wrapper {
    :nth-child(2) {
      pointer-events: none;
    }
  }
}

/deep/ .additional .field-wrapper {
  margin-bottom: 32px;
}

/deep/ .wide label {
  width: 160px;
}
/deep/ .additional-options-radio.checked {
  z-index: 9999;
}

/deep/ .v-radio-input-element {
  width: fit-content;
  label {
    font-family: Lato-Regular, Arial, Helvetica, "sans-serif";
  }
}

/*for radio block*/
/deep/ .v-radio-input__wrapper:hover {
  .check {
    border: 1px solid $primary-color;
  }

  label {
    color: $main-text-color;
    font-family: Lato-Regular, Arial, Helvetica, "sans-serif";
  }
}
</style>
